import { DEFAULT_ICONS } from '@repo/common/constants';
import { EntityType } from '@repo/common/enums/entityType';
import { Icon } from '@repo/foundations';
import { colors } from '@repo/theme/primitives';
import {
	IconBook,
	IconChartHistogram,
	IconFileAnalytics,
	IconFolders,
	IconMessages,
} from '@tabler/icons-react';
import { ENTITY_NODE_HEADER_INTEGRATION_ICON_SIZE } from '../EntityNodeHeader/EntityNodeHeader.constants';
import type { EntityTypeIconOptions } from './EntityTypeIcon.types';

interface EntityTypeIconProps {
	entityType: EntityTypeIconOptions;
	size?: number;
}

function EntityTypeIcon({
	entityType,
	size = ENTITY_NODE_HEADER_INTEGRATION_ICON_SIZE,
}: EntityTypeIconProps) {
	switch (entityType) {
		case 'collection':
			return <IconFolders color={colors.teal[5]} size={size} />;
		case 'dictionary_term':
			return <IconBook color={colors.primary[5]} size={size} />;
		case 'document':
			return <IconFileAnalytics color={colors.indigo[5]} size={size} />;
		case 'metric':
			return <IconChartHistogram color={colors.primary[5]} size={size} />;
		case 'question':
			return <IconMessages color={colors.yellow[5]} size={size} />;
		case 'bi_dashboard':
			return (
				<Icon
					name={
						DEFAULT_ICONS[EntityType.bi_dashboard]?.iconName ??
						'customDashboard'
					}
					iconWidth={size}
					iconHeight={size}
					style={{ width: size, height: size }}
				/>
			);
		case 'bi_metric':
			return (
				<Icon
					name={
						DEFAULT_ICONS[EntityType.bi_metric]?.iconName ?? 'chartHistogram'
					}
					iconWidth={size}
					iconHeight={size}
					style={{ width: size, height: size }}
				/>
			);
		default:
			return null;
	}
}

export default EntityTypeIcon;
